import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import ChatsPage from "@/pages/ChatsPage";
import Products from "@/pages/Products";
import Promotions from "@/pages/Promotions";
import Billing from "@/pages/Billing";
import SettingsPage from "@/pages/SettingsPage";
import Simulator from "@/pages/Simulator";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="flex h-screen items-center justify-center bg-ink">
        <div className="flex gap-1.5">
          {[0, 1, 2].map((i) => (
            <span key={i} className="h-2.5 w-2.5 animate-bounce-dot rounded-full bg-mint" style={{ animationDelay: `${i * 0.15}s` }} />
          ))}
        </div>
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<AuthPage mode="login" />} />
          <Route path="/register" element={<AuthPage mode="register" />} />
          <Route path="/onboarding" element={<Protected><Onboarding /></Protected>} />
          <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
          <Route path="/chats" element={<Protected><ChatsPage /></Protected>} />
          <Route path="/c/:chatId" element={<Protected><ChatsPage /></Protected>} />
          <Route path="/products" element={<Protected><Products /></Protected>} />
          <Route path="/promotions" element={<Protected><Promotions /></Protected>} />
          <Route path="/billing" element={<Protected><Billing /></Protected>} />
          <Route path="/settings" element={<Protected><SettingsPage /></Protected>} />
          <Route path="/simulator" element={<Protected><Simulator /></Protected>} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" toastOptions={{ style: { background: "#141a13", border: "1px solid rgba(255,255,255,0.1)", color: "#f2f6f1", borderRadius: "12px" } }} />
    </AuthProvider>
  );
}

export default App;
